import { useEffect } from "react";

const DEFAULT_TITLE = "Oliver Bujdoš — Software Developer";

// CRA is client-rendered: crawlers read the static index.html title for "/",
// this hook only keeps tab titles/history correct for humans on route changes.
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — Oliver Bujdoš` : DEFAULT_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
